import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import DashboardLayout from './components/DashboardLayout';
import Home from './pages/Home';
import Portfolio from './pages/Portfolio';
import GlobalLeaderboard from './pages/GlobalLeaderboard';
import CollegeLeaderboard from './pages/CollegeLeaderboard';
import Assessments from './pages/Assessments';
import EditProfile from './pages/EditProfile';
import LandingPage from './pages/LandingPage';
import Feedback from './pages/Feedback';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-xl">Loading...</div>
      </div>
    );
  }

  return user ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          
          <Route path="/dashboard" element={
            <PrivateRoute>
              <DashboardLayout />
            </PrivateRoute>
          }>
            <Route index element={<Home />} />
            <Route path="portfolio" element={<Portfolio />} />
            <Route path="assessments" element={<Assessments />} />
            <Route path="global-leaderboard" element={<GlobalLeaderboard />} />
            <Route path="college-leaderboard" element={<CollegeLeaderboard />} />
            <Route path="edit-profile" element={<EditProfile />} />
            <Route path="feedback" element={<Feedback />} />
          </Route>
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
